export const AppRoutes = {
    support: `/support`,
    terms: `/terms`,
    privacy: `/privacy`,
}
